




















import NewAdForm from '@/components/User/NewAdForm.vue';

export default {
  name: 'NewAd',
  components: {
    NewAdForm,
  },
};
